import { useEffect, useState } from "react";
import HeroIconSrc from "shared/assets/images/hero-icon.png";
import { ReactComponent as MailIcon } from "shared/assets/images/icon-mail.svg";
import { ReactComponent as LockIcon } from "shared/assets/images/icon-lock.svg";
import { HeroSteps } from "./Hero";
import { Trans, useTranslation } from "react-i18next";
import { Form, Input } from "antd";
import { signUp } from "aws-amplify/auth";
import { registerUser } from "shared/service/StrmService";
import i18n from "translation";
import { toast } from "react-toastify";
import {
  dataLayerViewedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";
import { Link } from "react-router-dom";
import { saveReturnURL } from "shared/helpers/auth-functions";

interface Props {
  setCurrentStep: any;
}

const HeroSignup: React.FC<Props> = (props) => {
  const { setCurrentStep } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const form = Form.useFormInstance();
  const username = Form.useWatch("username", form);
  const password = Form.useWatch("password", form);
  const { t } = useTranslation();

  const onClickNext = async () => {
    setLoading(true);
    const { username, password, spotify } = form.getFieldsValue(true);
    const name = spotify?.name;
    try {
      const user = await signUp({
        username,
        password,
        options: {
          userAttributes: {
            name,
          },
          autoSignIn: true,
        },
      });

      await registerUser({
        name,
        cognitoUsername: user.userId,
        login: username,
        currentLanguage: i18n.language,
      });
      setCurrentStep(HeroSteps.Verification);
    } catch (error: any) {
      if (error.name === "UsernameExistsException")
        toast.error<string>(t("pages.CadastreSe.usuarioExistente"), {
          autoClose: 10000,
        });
      else if (error.name === "InvalidPasswordException")
        toast.error<string>(t("pages.CadastreSe.criterioSenha"));
      else toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dataLayerViewedEvent({
      ...tagManagerEvent.Hero.S4A_HERO_SIGN_UP,
    });
  }, []);

  return (
    <div className="signup full-height">
      <div
        className="background-default"
        style={{
          backgroundImage: `url(${HeroIconSrc})`,
        }}
      >
        <div style={{ padding: "0 40px" }}>
          <p className="body-regular">
            <Trans i18nKey={t("pages.StrmHero.confirmMail")} />
          </p>

          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: t("pages.CadastreSe.emailRequired"),
              },
              {
                type: "email",
                message: t("pages.CadastreSe.emailValido"),
              },
            ]}
          >
            <Input
              placeholder={t("pages.CadastreSe.email")}
              prefix={<MailIcon className="input-prefix" />}
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: t("pages.CadastreSe.passwordRequired"),
              },
            ]}
            extra={t("pages.CadastreSe.criterioSenha")}
          >
            <Input.Password
              placeholder={t("pages.CadastreSe.senha")}
              size="large"
              prefix={<LockIcon className="input-prefix" />}
            />
          </Form.Item>
          <div className="text-register">
            {t("pages.StrmHero.alreadyRegistered")}
            <Link
              style={{ marginLeft: 6 }}
              to="/login"
              onClick={() => {
                saveReturnURL("/strm-hero");
              }}
            >
              {t("pages.StrmHero.loginHere")}
            </Link>
          </div>
        </div>
      </div>
      <div className="footer">
        <button
          className="botao-roxo"
          onClick={onClickNext}
          disabled={!username || !password || loading}
          style={{ width: "100%" }}
          type="button"
        >
          {t("pages.StrmHero.meeetStrmNow")}
        </button>
      </div>
    </div>
  );
};

export default HeroSignup;
